import { useEffect, useState } from 'react'
import { ArchiveRestore } from 'lucide-react'
import { Alerta, Boton, Cargando } from '../../components/kit'
import { BarraSeleccion } from '../../components/inventario/BarraSeleccion'
import { DialogoBaja } from '../../components/inventario/DialogoBaja'
import { TablaBienes } from '../../components/inventario/TablaBienes'
import { useBajas } from '../../queries/useInventario'
import { BienEnBaja } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'
import { formatoFecha } from '../../utils/fecha'

/**
 * Los bienes marcados para dar de baja. Ya no aparecen en las planchetas; conservan la
 * oficina donde estaban, y revertir la baja los devuelve ahí. El proceso de baja (actas,
 * resoluciones) vendrá después.
 */
export default function Bajas() {
  const bajas = useBajas()
  const [seleccion, setSeleccion] = useState<Set<number>>(new Set())
  const [revirtiendo, setRevirtiendo] = useState<BienEnBaja[] | null>(null)
  const lista = bajas.data ?? []

  // La selección no sobrevive a bienes que ya salieron de Bajas.
  useEffect(() => {
    const ids = new Set((bajas.data ?? []).map((b) => b.id))
    setSeleccion((s) => new Set([...s].filter((id) => ids.has(id))))
  }, [bajas.data])

  return (
    <div className="pila pila--amplia">
      <header className="pagina__cabecera">
        <h1 className="dcc-t-heading-m">Bajas</h1>
        <p className="texto-secundario">
          Bienes marcados para dar de baja. Ya no aparecen en las planchetas. Si se revierte la baja, el bien vuelve a la oficina donde
          estaba.
        </p>
      </header>

      {bajas.isLoading && <Cargando />}
      {bajas.isError && <Alerta tipo="error">{mensajeDeError(bajas.error)}</Alerta>}
      {bajas.data && !lista.length && (
        <p className="texto-secundario">No hay bienes para dar de baja. Se marcan desde Bienes, desde la ficha de un bien o desde su oficina.</p>
      )}
      {lista.length > 0 && (
        <>
          <BarraSeleccion
            texto={`${lista.length.toLocaleString('es-CL')} ${lista.length === 1 ? 'bien' : 'bienes'}`}
            marcados={seleccion.size}
            acciones={[
              {
                clave: 'revertir',
                texto: 'Revertir baja',
                Icono: ArchiveRestore,
                onClick: () => setRevirtiendo(lista.filter((b) => seleccion.has(b.id))),
              },
            ]}
            onDesmarcar={() => setSeleccion(new Set())}
          />
          <TablaBienes
            bienes={lista}
            etiqueta="Bienes para dar de baja"
            mostrarRecinto
            sin={['serie', 'estado']}
            seleccion={seleccion}
            onSeleccion={setSeleccion}
            columnas={[
              {
                titulo: 'Baja',
                celda: (b) =>
                  b.baja ? (
                    <>
                      {b.baja.motivo || 'Sin motivo'}
                      <span className="tabla__sub">{[formatoFecha(b.baja.fecha), b.baja.usuario].filter(Boolean).join(' · ')}</span>
                    </>
                  ) : (
                    '—'
                  ),
              },
            ]}
            acciones={(b) => (
              <Boton tam="sm" variante="text" icono={ArchiveRestore} onClick={() => setRevirtiendo([b])}>
                Revertir
              </Boton>
            )}
          />
        </>
      )}

      {revirtiendo && (
        <DialogoBaja bienes={revirtiendo} revertir onCerrar={() => setRevirtiendo(null)} onHecho={() => setSeleccion(new Set())} />
      )}
    </div>
  )
}
